(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["city-journeys"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('city-journeys')) {
    class CityJourneys extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cj-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-cj-prev]');
        this.next = this.querySelector('[data-cj-next]');
        this.dotsEl = this.querySelector('[data-cj-dots]');
        this.smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.prev.addEventListener('click', () => this.go(this.page() - 1));
        this.next.addEventListener('click', () => this.go(this.page() + 1));

        this.addEventListener('click', (event) => {
          const selectBtn = event.target.closest('[data-cj-select]');
          if (selectBtn) this.select(selectBtn.dataset.cjSelect, true);
          const dot = event.target.closest('[data-cj-dot]');
          if (dot) this.go(Number(dot.dataset.cjDot));
        });

        // Theme editor: clicking a city block selects it
        this.addEventListener('shopify:block:select', (event) => {
          const id = event.target.dataset && event.target.dataset.cjCard;
          if (!id) return;
          this.select(id, false);
          event.target.scrollIntoView({ behavior: this.smooth, block: 'nearest', inline: 'center' });
        });

        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => this.layout());
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.layout());
        }
        this.layout();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
      }

      step() {
        const card = this.track.querySelector('.cj-card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const size = card.offsetWidth + gap;
        const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / size));
        return perView * size;
      }

      maxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      pages() {
        const max = this.maxScroll();
        return max < 2 ? 1 : Math.ceil(max / this.step() - 0.05) + 1;
      }

      page() {
        const max = this.maxScroll();
        if (max < 2) return 0;
        if (this.track.scrollLeft >= max - 2) return this.pages() - 1;
        return Math.round(this.track.scrollLeft / this.step());
      }

      go(index) {
        const pages = this.pages();
        const i = Math.max(0, Math.min(pages - 1, index));
        const left = i === pages - 1 ? this.maxScroll() : i * this.step();
        this.track.scrollTo({ left, behavior: this.smooth });
      }

      layout() {
        const pages = this.pages();
        if (this.dotsEl && this.dotsEl.children.length !== pages) {
          this.dotsEl.replaceChildren(
            ...Array.from({ length: pages }, (_, i) => {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'cj__dot';
              b.dataset.cjDot = i;
              b.setAttribute('aria-label', `Go to slide ${i + 1} of ${pages}`);
              return b;
            })
          );
        }
        this.classList.toggle('is-static', pages < 2);
        this.update();
      }

      update() {
        const current = this.page();
        const max = this.maxScroll();
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        if (this.dotsEl) {
          Array.from(this.dotsEl.children).forEach((dot, i) => {
            dot.classList.toggle('is-active', i === current);
            if (i === current) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }

      select(id, fromClick) {
        this.querySelectorAll('[data-cj-card]').forEach((card) => {
          const on = card.dataset.cjCard === id;
          card.classList.toggle('is-active', on);
          const btn = card.querySelector('[data-cj-select]');
          if (btn) btn.setAttribute('aria-pressed', String(on));
        });

        const card = this.querySelector(`[data-cj-card="${id}"]`);
        if (fromClick && card) {
          const t = this.track.getBoundingClientRect();
          const c = card.getBoundingClientRect();
          if (c.left < t.left || c.right > t.right) {
            this.track.scrollBy({ left: c.left - t.left - (t.width - c.width) / 2, behavior: this.smooth });
          }
        }

        let target = null;
        this.querySelectorAll('[data-cj-panel]').forEach((panel) => {
          const on = panel.dataset.cjPanel === id;
          panel.hidden = !on;
          if (on) {
            target = panel;
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });

        // Scroll the tours into view if they are below the screen
        if (fromClick && target) {
          const rect = target.getBoundingClientRect();
          if (rect.top > window.innerHeight - 120) {
            target.scrollIntoView({ behavior: this.smooth, block: 'start' });
          }
        }
      }
    }

    customElements.define('city-journeys', CityJourneys);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('news-ticker')) {
    class NewsTicker extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.news-ticker__track');
        this.group = this.querySelector('.news-ticker__group');
        if (!this.track || !this.group) return;

        // Make every announcement visible (the old slider hid all but one)
        this.group.querySelectorAll('[aria-hidden]').forEach((el) => el.removeAttribute('aria-hidden'));

        // Add a separator after every announcement
        const separator = this.dataset.separator;
        if (separator) {
          Array.from(this.group.children).forEach((item) => {
            if (item.classList.contains('news-ticker__sep')) return;
            const sep = document.createElement('span');
            sep.className = 'news-ticker__sep';
            sep.setAttribute('aria-hidden', 'true');
            sep.textContent = separator;
            item.after(sep);
          });
        }

        this.build = this.build.bind(this);
        this.resizeObserver = new ResizeObserver(this.build);
        this.resizeObserver.observe(this);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.build);
        this.build();

        // Pause while a block is selected in the theme editor
        this.addEventListener('shopify:block:select', () => this.classList.add('is-paused'));
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      build() {
        this.track.querySelectorAll('.news-ticker__group--clone').forEach((el) => el.remove());

        const groupWidth = this.group.scrollWidth;
        if (!groupWidth) return;

        // Enough copies to always fill the visible width, plus one for the loop
        const copies = Math.ceil(this.clientWidth / groupWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.classList.add('news-ticker__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        }

        const speed = Number(this.dataset.speed) || 60; // pixels per second
        this.style.setProperty('--ticker-distance', `${groupWidth}px`);
        this.style.setProperty('--ticker-duration', `${groupWidth / speed}s`);
        this.classList.add('is-ready');
      }
    }

    customElements.define('news-ticker', NewsTicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Scroll back to the card from the URL hash */
  (() => {
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) card.scrollIntoView({ behavior: 'instant' });
        },
        { once: true }
      );
    }
  })();

  /* ---------- Wishlist: uses the Site Header wishlist ----------
     The header saves product handles in localStorage "yuoom_wishlist"
     and toggles any button with data-yuoom-wishlist="handle".
     This part keeps the hearts on the cards in sync and shows a toast. */
  if (!window.__cardWishBound) {
    window.__cardWishBound = true;

    const KEY = 'yuoom_wishlist';

    const read = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };

    const sync = () => {
      const list = read();
      document.querySelectorAll('.card-wish [data-yuoom-wishlist]').forEach((btn) => {
        const on = list.includes(btn.getAttribute('data-yuoom-wishlist'));
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', String(on));
      });
    };

    let toastTimer;
    const toast = (message) => {
      const el = document.querySelector('[data-card-wish-toast]');
      if (!el) return;
      el.querySelector('[data-card-wish-msg]').textContent = message;
      el.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3000);
    };

    // The header's click handler runs first and saves the trip; here we only react to it.
    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('.card-wish-toast__view')) {
          const el = document.querySelector('[data-card-wish-toast]');
          if (el) el.classList.remove('is-visible');
          return;
        }

        const btn = event.target.closest('.card-wish [data-yuoom-wishlist]');
        if (!btn) return;

        const handle = btn.getAttribute('data-yuoom-wishlist');

        // Fallback if the Site Header script is not on the page
        if (!window.__yhBound) {
          event.preventDefault();
          const list = read();
          const index = list.indexOf(handle);
          if (index > -1) list.splice(index, 1);
          else list.unshift(handle);
          write(list);
        }

        const saved = read().includes(handle);
        sync();
        toast(`${saved ? 'Saved' : 'Removed'} ${btn.dataset.title || 'trip'}`);
      },
      true
    );

    // Keep hearts right when new cards load (infinite scroll), in other tabs, and on back/forward
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        sync();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('storage', (event) => {
      if (event.key === KEY) sync();
    });
    window.addEventListener('pageshow', sync);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  }

  /* ---------- Quick filter dropdowns ---------- */
  if (!customElements.get('quick-filters')) {
    class QuickFilters extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('details.quick-filter'));

        this.panels.forEach((panel) => {
          panel.addEventListener('toggle', () => {
            if (!panel.open) return;
            this.panels.forEach((other) => {
              if (other !== panel) other.open = false;
            });
          });
        });

        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.onKey = (event) => {
          if (event.key !== 'Escape') return;
          const open = this.panels.find((panel) => panel.open);
          if (open) {
            open.open = false;
            open.querySelector('summary').focus();
          }
        };

        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }

      closeAll() {
        this.panels.forEach((panel) => (panel.open = false));
      }
    }

    customElements.define('quick-filters', QuickFilters);
  }

  } catch(e) { console.error(e); }
})();
})();
